export const POLICY_OLIGARCHY_GUILD_INCOME_BONUS = 1;

export const POLICY_OLIGARCHY_GUILD_MAX_COUNT_IN_ONE_CITY = 2;